export const PetHelper = {
  getPetValidator () {
    return {
      name: '',
      breedId: '',
      isValid: false,
      check (model) {
        const name = (model.name || '').trim()
        this.name = name ? '' : 'Please enter a name'
        this.breedId = model.breedId ? '' : 'Please select a breed'
        this.isValid = !this.name && !this.breedId
      }
    }
  },
  getPetAndBreedValidator () {
    return {
      name: '',
      breedId: '',
      isValid: false,
      check (model) {
        const name = (model.name || '').trim()
        this.name = name ? '' : 'Please enter a name'
        this.breedId = model.breedId ? '' : 'Please select a breed'
        this.isValid = !this.name && !this.breedId
      }
    }
  }
}
